import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function parallaxBg() {
    const element = document.querySelector(".bg-graphic");
    const pageHeight = document.body.clientHeight;

    gsap.to(element, {
        y: -1 * pageHeight / 50,
        duration: 1,
        scrollTrigger: {
            element,
            start: "top top",
            scrub: 1,
            markers: false,
        }
    })
}

export { parallaxBg }